/**
 * Saved views are a client-side concern for now (design_handoff open question
 * #4): stored per-browser in localStorage as a name + URL search string. If
 * the backend ever grows saved-view storage, swap this module's storage layer
 * without touching InventoryPage.
 */
const STORAGE_KEY = 'leatherback.inventory.savedViews';

export interface SavedView {
  id: string;
  name: string;
  search: string;
}

export function loadSavedViews(): SavedView[] {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (entry): entry is SavedView =>
        typeof entry === 'object' &&
        entry !== null &&
        typeof (entry as SavedView).id === 'string' &&
        typeof (entry as SavedView).name === 'string' &&
        typeof (entry as SavedView).search === 'string',
    );
  } catch {
    return [];
  }
}

export function saveSavedViews(views: SavedView[]): void {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(views));
}

export function addSavedView(name: string, search: string): SavedView[] {
  const views = loadSavedViews();
  const view: SavedView = { id: crypto.randomUUID(), name, search };
  const next = [...views, view];
  saveSavedViews(next);
  return next;
}

export function removeSavedView(id: string): SavedView[] {
  const next = loadSavedViews().filter((view) => view.id !== id);
  saveSavedViews(next);
  return next;
}
